export const handleOutsideClick = (e, onClose) => {
  if (e.target === e.currentTarget) {
    onClose();
  }
};